import Axios from 'axios';

const restDataCache = {};
export default function RESTDataCache(dataPath, cacheKey) {
  if (restDataCache[cacheKey]) {
    return Promise.resolve(restDataCache[cacheKey]);
  }
  if (typeof dataPath === 'object') {
    return Promise.resolve(dataPath);
  }
  return Axios.get(dataPath).then(response => {
    restDataCache[cacheKey] = response.data;
    return response.data;
  });
}
